import { resetFilteringStateAction } from "app/pages/sales-intelligence/modules/advanced-search-filtering/store/action-creators";
import { trackError } from "app/pages/sales-intelligence/utils/errors/tracking";
import { errorCategoryMap, SiError } from "app/pages/sales-intelligence/utils/errors/types";
import { SwRedux } from "app/services/SwRedux";

/**
 * Clears the filtering state on every advanced-search arrival (new-search and saved-search), before the
 * page mounts. This re-arms `isInitialFiltersReady` and the leads filters so the route's writers re-seed
 * from a clean slate. `onEnter` (not a React effect / `onExit`) so it fires deterministically on every
 * entry — incl. fresh load / deep-link — independent of component lifecycle (the new↔saved leaves share
 * an abstract parent and don't unmount, but each leaf's `onEnter` still fires on the transition).
 */
export const onEnterAdvancedSearchPage = () => {
    try {
        SwRedux.getInstance().dispatch(resetFilteringStateAction());
    } catch (error) {
        trackError(
            new SiError(
                "Failed to execute router hook",
                {
                    category: errorCategoryMap.service,
                    operation: "onEnterAdvancedSearchPage",
                },
                { cause: error },
            ),
        );
    }
};
